import React, { useEffect, useState } from "react";

import backicon from "../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../customformComponent/customForm/DynamicForm";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import axiosInstance from "../../../services/api/API";
import AddVehicleDetails from "../LogisticsComponents/AddVehicleDetails";
import VehicleList from "../LogisticsComponents/VehicleList";
import AddSpareParts from "../LogisticsComponents/AddSpareParts";
import AddAccessories from "../LogisticsComponents/AddAccessories";
import { showCustomAlert } from "../../../customComponents/CustomSweetAlert";
import Loader from "../../../customComponents/CustomLoader";

const AddLogisticsLists = () => {
  const [formData, setFormData] = useState({});
  const [vendoroptions, setVendorOptions] = useState([]);
  const [fieldsdisabled, setFieldsDisabled] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const [activeComponent, setActiveComponent] = useState(null);
  const [isVehicleDetailsSubmitted, setisVehicleDetailsSubmitted] =
    useState(false);
  const [isSparePartDetailsSubmitted, setisSparePartDetailsSubmitted] =
    useState(false);
  const [isdistributor, setisdistributor] = useState(false);
  const [isMainFormSubmitted, setIsMainFormSubmitted] = useState(false);
  const [logisticComapanies, setLogisticCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [initialrender, setInitialRender] = useState(true);
  const [BUSINESSPARTNERID, SETBUSINESSPRTNERID] = useState();
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const userType = localStorage.getItem("UserType");
  const navigate = useNavigate();
  const location = useLocation();
  const [LOGISTICID, setLogisticID] = useState();
  const isEdit = location.state?.isEdit || false;
  const logisticID = location.state?.data?.logistic_id || null;

  useEffect(() => {
    if (isEdit && logisticID) {
      fetchLogisticDetails(logisticID);
    }
  }, [isEdit, logisticID]);

  const fetchLogisticDetails = async (logisticID) => {
    try {
      setLoading(true);
      // setFieldsDisabled(false)
      const response = await axiosInstance.get(
        `/logistics/edit/${logisticID}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const data = response.data?.data;
      setFormData({
        vendortype: data.vendor_type_id,
        business_partner_id: data.business_partner_id,
        companyname: data.vendor_on_board_id,
        status: data.status === 1 ? "Active" : "Inactive",
      });
      //  / setActiveComponent("vehicle")

      //  setIsMainFormSubmitted(true);
    } catch (error) {
      console.error("Error fetching logistics details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (formData) => {
    if (formData?.vendortype === 2) {
      setisdistributor(true);
    }
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    // Set validation errors if any
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);

    // SweetAlert confirmation before submission
    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to create a vendor in Logistics?",
      icon: "success",
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel",
     setLoading,
      callback: async () => {
        try {
          let payload = {
            vendor_type_id: formData?.vendortype,
            business_partner_id: formData?.business_partner_id,
            vendor_on_board_id: formData?.companyname,
            status: formData?.status === "Active" ? 1 : 0,
          };

          if (userType !== "superadmin") {
            payload.business_partner_id = businessPartnerId;
          }

          let response;
          if (isEdit) {
            // Edit logic
            response = await axiosInstance.patch(
              `/logistics/update/${logisticID}`,
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${authToken}`,
                },
              }
            );
          } else {
            // Create logic
            response = await axiosInstance.post("/logistics/create", payload, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            });
          }

          localStorage.setItem(
            "logistic_id",
            response?.data?.data?.responseData?.logistic_id
          );
          if (!isEdit) {
            SETBUSINESSPRTNERID(
              response?.data?.data?.responseData?.business_partner_id
            );
          }
          SETBUSINESSPRTNERID(
            response?.data?.data?.responseData?.business_partner_id
          );
          setLogisticID(response?.data?.data?.responseData?.logistic_id);
          setActiveComponent("vehicle");
          setIsMainFormSubmitted(true);
        } catch (error) {
          console.error("Error submitting form:", error);
          showCustomAlert({
            title: "Error",
            text: "Failed to create vendor. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);

    } catch (error) {
      console.log(error);
    }
  };
  useEffect(()=>{

vendortypeoptions()
  },[formData?.business_partner_id])
  useEffect(() => {
    const fetchLogisticCompanies = async () => {
      if (!formData.vendortype) return;
      try {
        const response = await axiosInstance.post(
          "/vendor/ddlvendorlist ",
          {
            vendor_type_id: formData?.vendortype,
            business_partner_id:
              formData?.business_partner_id || businessPartnerId,
            page: 0,
            pageSize: 1000,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const LogisticCompaniesList = response.data?.data?.map(
          (subproduct) => ({
            label: subproduct?.NAME,
            value: subproduct?.ID,
          })
        );

        setLogisticCompanies(LogisticCompaniesList);

        if (!initialrender) {
          setFormData((prevData) => ({
            ...prevData,
            companyname: "",
          }));
        }
        setInitialRender(false);
      } catch (error) {
        console.error("Error fetching subproduct list:", error);
      }
    };
    fetchLogisticCompanies();
  }, [formData.vendortype]);

  const vendortypeoptions = async () => {
    const payload={ business_partner_id:formData?.business_partner_id?formData?.business_partner_id:businessPartnerId==="0"?null:businessPartnerId,
       "ddltype":'logistic'
    }
   
    try {
      const response = await axiosInstance.post("/vendortype/ddlvendortype", 
        payload,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data;
      const vendoroptions = data.map((user) => ({
        value: user?.ID,
        label: user?.NAME,
      }));
      setVendorOptions(vendoroptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    vendortypeoptions();
    userTypedropdown();
  }, []);
  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            disabled: fieldsdisabled,
            validation: { required: true },
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "vendortype",
      label: "Vendor Type",
      type: "dropdown",
      required: true,
      disabled: fieldsdisabled,
      options: vendoroptions,

      gridClass: "col-lg-4",
    },
    {
      name: "companyname",
      label: "Vendor Name",
      type: "dropdown",
      options: logisticComapanies,
      disabled: fieldsdisabled,
      validation: { required: true },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      disabled: fieldsdisabled,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];
  useEffect(() => {
    if (isEdit) {
      setFieldsDisabled(true);
      setActiveComponent("vehicle");
    }
  }, []);

  return (
    <>
      <div
        className="backbutton mt-2 mb-2"
        onClick={() => navigate(ROUTES_NAVIGATION.LOGISTICS)}
      >
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Logistics</span>
      </div>
      <div className="form-container">
        <div className="d-flex flex-row justify-content-between">
          <div>
            <span className="cust-det-title mt-2 mb-2">
              {isEdit ? "Update Logistics" : "Add Logistics"}
            </span>
          </div>
          <div className="d-flex justify-content-center align-items-center flex-row gap-2">
            <button
              className={`logistics-btn ${
                activeComponent === "vehicle" ? "active" : ""
              }`}
              disabled={isMainFormSubmitted}
              onClick={() => {
                setActiveComponent("vehicle");
                setisVehicleDetailsSubmitted(false);
              }}
            >
              Add Vehicle Details
            </button>
            <button
              className={`logistics-btn ${
                activeComponent === "spare" ? "active" : ""
              }`}
              onClick={() => {
                setActiveComponent("spare");
                setisVehicleDetailsSubmitted(true);
              }}
            >
              Add Spare Parts
            </button>
            <button
              className={`logistics-btn ${
                activeComponent === "accessories" ? "active" : ""
              }`}
              onClick={() => {
                setActiveComponent("accessories");
              }}
            >
              Add Accessories
            </button>
          </div>
        </div>
        {loading ? (
          <Loader /> 
        ) : (
          <>
            <DynamicForm
              formConfig={CustomerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              fieldsdisabled={fieldsdisabled}
            />
            {activeComponent === "vehicle" && (
              <div className="mt-5">
                <AddVehicleDetails
                  isVehicleDetailsSubmitted={isVehicleDetailsSubmitted}
                  setisVehicleDetailsSubmitted={setisVehicleDetailsSubmitted}
                  isMainFormSubmitted={isMainFormSubmitted}
                  setIsMainFormSubmitted={setIsMainFormSubmitted}
                  logisticID={logisticID}
                  LOGISTICID={LOGISTICID}
                  BUSINESSPARTNERID={BUSINESSPARTNERID}
                />
              </div>
            )}
            {activeComponent === "spare" && (
              <div className="mt-5">
                <AddSpareParts
                  isSparePartDetailsSubmitted={isSparePartDetailsSubmitted}
                  setisSparePartDetailsSubmitted={setisSparePartDetailsSubmitted}
                  isMainFormSubmitted={isMainFormSubmitted}
                  setIsMainFormSubmitted={setIsMainFormSubmitted}
                  isdistributor={isdistributor}
                  logisticID={logisticID}
                  LOGISTICID={LOGISTICID}
                  BUSINESSPARTNERID={BUSINESSPARTNERID}
                />
              </div>
            )}
            {activeComponent === "accessories" && (
              <div className="mt-5">
                <AddAccessories
                  isdistributor={isdistributor}
                  isMainFormSubmitted={isMainFormSubmitted}
                  setIsMainFormSubmitted={setIsMainFormSubmitted}
                  logisticID={logisticID}
                  LOGISTICID={LOGISTICID}
                  BUSINESSPARTNERID={BUSINESSPARTNERID}
                />
              </div>
            )}
          </>
        )}
        {!isMainFormSubmitted && (
          <div className="btncontainer mt-3 gap-2">
            <button
              onClick={() => handleFormSubmit(formData)}
              className="submit-btn"
            >
              {isEdit ? "Update" : "Submit"}
            </button>
          </div>
        )}
      </div>
    </>
  );
}  
export default AddLogisticsLists